const doc = [({"da":({"js":({"admin":({"sending_rules":({"create_card":({"create_sending_rule":"Opret udsendingsregel"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;